<template>
  <PageProfileFeedLayout>
    <Card>
      <NamiLoading v-if="pending" />
      <NoResults
        v-else-if="organizations?.length === 0"
        :message="translate('site.user.id.organizations.no_orgs')"
      />
      <div
        v-else-if="organizations"
        class="grid lg:grid-cols-2 2xl:grid-cols-3 gap-4"
      >
        <OrganizationCard v-for="org in organizations" :org="org" no-follow />
      </div>
    </Card>
  </PageProfileFeedLayout>
</template>

<script setup lang="ts">
import { Organization, type UserEntity } from "~/src/api";

const props = defineProps<{
  user: UserEntity;
}>();

const route = useRoute();
const nuxtApp = useNuxtApp();
const { t: translate } = nuxtApp.$i18n.global;

const { pending, data: organizations } = useAsyncData(
  `user-${route.params.username}-organizations`,
  async () => {
    const [ownedOrgs, memberOrgs] = await Promise.all([
      Organization.search({ ownerId: props.user.id }),
      Organization.search({ memberId: props.user.id }),
    ]);

    const ownedOrgIds = ownedOrgs.data.map(({ id }) => id);

    return ownedOrgs.data.concat(
      memberOrgs.data.filter(({ id }) => !ownedOrgIds.includes(id)),
    );
  },
  {
    getCachedData: (key) => useNuxtData(key).data.value,
  },
);
</script>
